import PropTypes from 'prop-types'

import AccessibilityFeatures from '../../../Accessibility'
import TabListSection from '../TabListSection'

const PANEL_KEY = 'accessibility'

const AccessibilityFeaturesPanel = ({ eventKey }) => (
  <TabListSection
    condition={eventKey === PANEL_KEY}
    eventKey={PANEL_KEY}
  >
    <AccessibilityFeatures />
  </TabListSection>
)

export default AccessibilityFeaturesPanel

AccessibilityFeaturesPanel.propTypes = {
  eventKey: PropTypes.string.isRequired
}
